import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEditIncomePage = {
  alert: {
    error: 'applicant-edit-income.form.alert.error',
  },
  footer: {
    root: 'applicant-edit-income.footer.root',
  },
  form: {
    amountInput: 'applicant-edit-income.form.amount-input',
    amountInputError: 'applicant-edit-income.form.amount-input-error',
    cancelButton: 'applicant-edit-income.form.cancel-button',
    employerNameInput: 'applicant-edit-income.form.employer-name-input',
    employerNameInputError:
      'applicant-edit-income.form.employer-name-input-error',
    frequencySelect: 'applicant-edit-income.form.frequency-select',
    frequencySelectError: 'applicant-edit-income.form.frequency-select-error',
    h1: 'applicant-edit-income.form.h1',
    h2: 'applicant-edit-income.form.h2',
    hasAdditionalIncomeSelect:
      'applicant-edit-income.form.has-additional-income-select',
    hasAdditionalIncomeSelectError:
      'applicant-edit-income.form.has-additional-income-select-error',
    incomeTypeSelect: 'applicant-edit-income.form.income-type-select',
    incomeTypeSelectError:
      'applicant-edit-income.form.income-type-select-error',
    jobTitleInput: 'applicant-edit-income.form.job-title-input',
    jobTitleInputError: 'applicant-edit-income.form.job-title-input-error',
    monthSelect: 'applicant-edit-income.form.month-select',
    monthSelectError: 'applicant-edit-income.form.month-select-error',
    root: 'applicant-edit-income.form.root',
    submitButton: 'applicant-edit-income.form.submit-button',
    yearSelect: 'applicant-edit-income.form.year-select',
    yearSelectError: 'applicant-edit-income.form.year-select-error',
  },
  header: {
    drawerButton: 'applicant-edit-income.header.drawer-button',
    previousStepButton: 'applicant-edit-income.header.previous-step-button',
    root: 'applicant-edit-income.header.root',
  },
  progress: {
    root: 'applicant-edit-income.progress.root',
  },
} as const satisfies PageLocatorMap;
